/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:da84a93d-44d0-49b2-8a58-2bc5feab98c8",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_WUjJtlzRQ",
    "aws_user_pools_web_client_id": "75vbct2p3d8bqqb3ljgg05amo4",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "yieldyak-analytics-amplify-bucket155406-staging",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
